"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesSideBarSection = exports.default = void 0;
const react_1 = __importStar(require("react"));
const categories_facet_nav_component_1 = require("./categories-facet-nav.component");
const common_1 = require("../../common");
const generic_1 = require("../../../../generic");
const localization_1 = require("../../../../localization");
// this is temporary while work on EN-3049 is in progress
// when EN-3049 is complete, files in the v2 folder will replace the existing side-bar files
const v2_1 = require("../../side-bar/sidebar-section/v2");
const sidebar_section_styles_1 = require("../../side-bar/sidebar-section/v2/sidebar-section.styles");
const tree_navigation_1 = require("../../tree-navigation");
const selectors_1 = require("../../../../store/selectors");
const CategoriesSideBarSection = ({ isCategoriesLoading, debouncedSearchTerm, }) => {
    const selectedOrganizationsIds = (0, selectors_1.useSelectedOrganizationsIdsSelector)();
    const [isSimpleView, setIsSimpleView] = (0, react_1.useState)(true);
    const [isCategoriesExpanded, setIsCategoriesExpanded] = (0, react_1.useState)(false);
    const [isCategoriesDisplayed, setIsCategoriesDisplayed] = (0, react_1.useState)(true);
    const [treeExpandOverride, setTreeExpandOverride] = (0, react_1.useState)(null);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [pending, startTransition] = (0, react_1.useTransition)();
    const resetSelections = () => {
        setIsSimpleView(true);
        setIsCategoriesDisplayed(true);
        setIsCategoriesExpanded(false);
        setTreeExpandOverride(null);
    };
    (0, react_1.useEffect)(() => {
        resetSelections();
    }, [selectedOrganizationsIds]);
    const handleCollapseAll = () => {
        startTransition(() => {
            setIsCategoriesExpanded(false);
            setTreeExpandOverride(tree_navigation_1.CollapseState.Collapse);
        });
    };
    const handleExpandAll = () => {
        startTransition(() => {
            setIsCategoriesExpanded(true);
            setTreeExpandOverride(tree_navigation_1.CollapseState.Expand);
        });
    };
    return (react_1.default.createElement(v2_1.SidebarSection, { title: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(sidebar_section_styles_1.StyledControlIcons, null, react_1.default.createElement(v2_1.DisplayHideButton, { toggleDisplay: () => setIsCategoriesDisplayed((prevState) => !prevState), isDisplayed: isCategoriesDisplayed }), t({ key: 'CATEGORIES' })), react_1.default.createElement(sidebar_section_styles_1.StyledControlIcons, null, react_1.default.createElement(v2_1.SimpleHierarchyToggleButton, { isSimpleView: isSimpleView, toggleView: () => setIsSimpleView((prevState) => !prevState) }), pending ? react_1.default.createElement(common_1.ProcessingSpinner, null) : (react_1.default.createElement(v2_1.ExpandCollapseButton, { isExpanded: isCategoriesExpanded, toggleExpandState: isCategoriesExpanded ? handleCollapseAll : handleExpandAll })))) }, react_1.default.createElement(generic_1.Loading, { iconOrientation: "right", isLoading: isCategoriesLoading, progressSize: 25, showEllipsis: false }), isCategoriesDisplayed && !isCategoriesLoading
        && (react_1.default.createElement(categories_facet_nav_component_1.CategoriesFacetNavigation, { isSimple: isSimpleView, expandOverride: treeExpandOverride, debouncedSearchTerm: debouncedSearchTerm }))));
};
const MemoizedCategories = react_1.default.memo(CategoriesSideBarSection);
exports.default = MemoizedCategories;
exports.CategoriesSideBarSection = MemoizedCategories;
